export function openAuthRedirect(url: string) {
  const target = window.self === window.top ? "_self" : "_top";
  const opened = window.open(url, target);

  if (!opened && target === "_top") {
    window.open(url, "_blank", "noopener,noreferrer");
    return;
  }

  if (!opened) {
    window.location.assign(url);
  }
}
